<template>
  <div>
    <breadcrumb v-if="type" :routerList="[{to:'/agent/weeklyMeetingList',title:'网络运营会列表'},{title:'查看运营会纪要'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <el-form ref="form1" :model="formValue">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <div class="h-pieceTitle2" v-if="type" style="margin-bottom: 0.3rem;">
                    <h1>查看运营会纪要</h1>
                  </div>
                  <div class="h-pieceCon2">
                    <div class="h-formLine">
                      <div class="margin-top el-descriptions">
                        <div class="el-descriptions__body">
                          <table class ="meeting-table el-descriptions__table is-bordered bordered-spacing" style="table-layout: fixed; width: 100%">
                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">
                                客户基本信息
                              </th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                代理商名称
                              </th>
                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="agentName">
                                  <!--按照省区内签约网络选择-->
                                  {{formValue.agentName}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                签约渠道
                              </th>
                              <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="channelCode">
                                  {{formValue.channelCode | dictname('fl_sales_region_qudao')}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                所在省区
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="provinceCode">
                                  {{formValue.provinceCode | dictname('YlSalesArea_chanpin')}}
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                召开人
                              </th>
                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="conveneName">
                                  {{formValue.conveneName}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                参会人
                              </th>
                              <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="participants" >
                                  {{formValue.participants}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                运营会时间
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="weekTime" >
                                  {{formValue.weekTime}}
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">客户签约目标</th>
                            </tr>
                            <tr>
                              <th colspan="7"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月度履约预测</th>
                              <th colspan="5"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月预测支撑明细</th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月份</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">领域</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月目标（万）</th>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月预计达成（万）</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">预测履约率（%）</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">实际履约率（%）</th>
                              <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">填写</th>
                            </tr>
                            <!-- tbody v-for=(item,index) in lingyuList -->
                            <tr>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                      {{formValue.monthOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="fieldOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                      {{formValue.fieldOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="monthTargetOne" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.monthTargetOne }}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthExpectOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.monthExpectOne }}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="ycCompletionRateOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.ycCompletionRateOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="completionRateOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.completionRateOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="detailOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: left;">
                                      {{formValue.detailOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                            </tr>
                            <tr v-if="formValue.monthTwo">
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                      {{formValue.monthTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="fieldTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                      {{formValue.fieldTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="monthTargetTwo" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.monthTargetTwo }}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthExpectTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.monthExpectTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="ycCompletionRateTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.ycCompletionRateTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="completionRateTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.completionRateTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="detailTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: left;">
                                      {{formValue.detailTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                            </tr>


                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">签约目标用户</th>
                            </tr>
                            <tr>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                目标用户个数
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="targetUserNum" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.targetUserNum}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计覆盖用户
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiUserNum" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiUserNum}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年覆盖用户
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearUserNum" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearUserNum}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计覆盖率(%)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiCoverage" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiCoverage}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年覆盖率(%)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearCoverage" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearCoverage}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                未覆盖且无漏斗用户个数
                              </th>
                              <th colspan="9" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                本周行动计划
                              </th>
                            </tr>
                            <tr>
                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                {{formValue.noCoveredNoloudUserNum}}
                              </td>
                              <td v-if="formValue.noCoveredNoloudUserNum==0" colspan="9" class="el-descriptions-item__cell el-descriptions-item__content" style="white-space: pre-line;text-align: left!important;">
                                {{formValue.handInput}}
                              </td>

                              <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="5" class="el-descriptions-item__cell el-descriptions-item__content" style="white-space: pre-line;text-align: left!important;">
                                {{formValue.weekPlan}}
                              </td>
                              <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="4" class="el-descriptions-item__cell el-descriptions-item__content" style="white-space: pre-line;text-align: left!important;">
                                {{formValue.handInput}}
                              </td>

                            </tr>

                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">进销存盘点</th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计下单(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiOrder">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiOrder}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计安装(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiInstall">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiInstall}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计库存(万)
                              </th>
                              <td colspan="1" rowspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiInventory">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiInventory}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="6" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                库存消化行动方案
                              </th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年下单(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearOrder">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearOrder}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年安装(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearInstall">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearInstall}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="inventoryDigestionPlan">
                                  {{formValue.inventoryDigestionPlan}}
                                </el-form-item>
                              </td>
                            </tr>

                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">招标项目</th>
                            </tr>
                            <tr>
                              <th colspan="6" class="my-label el-descriptions-item__cell el-descriptions-item__label is-bordered-label">未来3个月内招标项目</th>
                              <th colspan="6" class="my-label el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月开标项目</th>
                            </tr>
                            <tr>
                              <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="threeMonthProject">
                                  {{formValue.threeMonthProject}}
                                </el-form-item>
                              </td>
                              <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthProject">
                                  {{formValue.monthProject}}
                                </el-form-item>
                              </td>
                            </tr>

                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">营销活动及产品培训</th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                活动类型
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="activityType">
                                  {{formValue.activityType}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                行动计划
                              </th>
                              <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="activityPlan">
                                  {{formValue.activityPlan}}
                                </el-form-item>
                              </td>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                预计下次召开时间
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="activityTime">
                                  {{formValue.activityTime}}
                                </el-form-item>
                              </td>
                            </tr>

                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                培训产品
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="trainingproduct">
                                  {{formValue.trainingproduct}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                图片
                              </th>
                              <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                <div style="float: left;width:200px">
                                  <el-image
                                      style="width: 200px; height: 100px"
                                      :src="url"
                                      :preview-src-list="srcList">
                                  </el-image>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div class="h-txtCenter h-mrt60" v-if="type">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import weekMeetingService from "@/api/loud/weekMeeting/weekMeetingService";
export default {
  props:{
    type: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return{
      formValue:{
        // 客户基本信息
        agentName: '',//代理商名称
        agentCode: '',//代理商编码
        channelName: '',//签约渠道
        channelCode: '',//签约渠道
        provinceName: '',//地区
        provinceCode: '',//地区
        conveneCode: '',//召开人编码
        conveneName: '',//召开人姓名
        participants: '',//参会人
        weekTime: '',//运营会时间
        //客户签约目标
        month: '',//月份
        field: '',//领域
        monthTarget: '',//本月目标
        monthExpect: '',//本月预期
        ycCompletionRate: '',//预测履约率
        completionRate: '',//实际履约率
        detail: '',//本月预测支撑明细填写
        // 签约目标用户
        targetUserNum: '',//目标用户个数
        leijiUserNum: '',//累计覆盖用户
        yearUserNum: '',//当年覆盖用户
        leijiCoverage: '',//累计覆盖率
        yearCoverage: '',//当年覆盖率
        noCoveredNoloudUserNum: '',//未覆盖且无漏斗用户个数
        weekPlan: '',//本周行动计划
        handInput: '',//本周行动计划
        // 进销存盘点
        leijiOrder: '',//累计下单
        leijiInstall: '',//累计安装
        leijiInventory: '',//累计库存
        inventoryDigestionPlan: '',//库存消化行动方案
        yearOrder: '',//当年下单
        yearInstall: '',//当年安装
        // 招标项目
        threeMonthProject: '', //未来3个月内招标项目
        monthProject: '',  //本月开标项目
        // 营销活动
        activityType: '',//活动类型
        activityPlan: '',//行动计划
        activityTime: '',//预计召开时间
        // 产品培训
        trainingproduct: '',//培训产品
      },
      url: '',
      srcList: []
    }
  },
  created() {

  },
  methods:{
    //更新值
    updateData(newValue) {
      this.formValue = newValue;
    },
    getDetail(val){
      weeklyMeetingApi.selectById(val).then(res=> {
        this.formValue = {
          ...res.obj
        }
        this.refid = this.formValue.fileId;
        //查询文件
        weeklyMeetingApi.selectMeetingReportFile({fileId:this.refid}).then(rd => {
          rd.msg.forEach(obj => {
            this.srcList.push('https://'+process.env.VUE_APP_AJAXURL+'/'+obj.saveurl);
          })
          this.url = 'https://'+process.env.VUE_APP_AJAXURL+'/'+rd.msg[0].saveurl;
        })
        //获取详情接口，根据id或者什么查看详情
      })
    },
    //返回
    backS(){
      this.$router.go(-1);
    }
  },
  mounted() {
    let id = this.$route.query.id
    if(this.type){
      this.getDetail(id)
    }
  }
}
</script>
<style scoped lang="scss">
.h-rowCon{
  font-size: 14px!important;
  font-weight: 400!important;
}
::v-deep .el-form-item__content{
  line-height: 30px;
}
::v-deep .meeting-table  th ,td {
  text-align: center!important;
  border: 1px solid #303133!important;
  border-right: none!important;
  border-bottom: none!important;
  vertical-align:middle;
  font-weight: normal!important;
}
.bordered-spacing{
  border-spacing: 0!important;
  border-right: 1px solid #303133!important;
  border-bottom: 1px solid #303133!important;
}

::v-deep .el-input__inner{
  height: 30px;
  line-height: 30px;
}
::v-deep .my-label {
  background: #fff2e5!important;
}
//::v-deep .my-label-lab {
//  background: #E8F5F8!important;
//}


::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
  line-height: 0.25rem;
}
::v-deep .el-input__icon{
  line-height: 30px;
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
  padding-bottom: 0;
}
::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell{
  padding: 6px;
}
.new-yulan{
  width: 100%;
  margin: 0 auto;
}
.new-yulan ul li{
  padding:5px 0
}
.new-yulan ul li h3{
  text-align: left;
  font-weight: 400;
  color: #0e75e9;
  font-size: 14px
}
.new-yulan ul li h3 i{
  padding: 0 5px;
  color: #606266
}
.new-yulan ul li h3 span{
  text-align: right;
  color: #606266;
  float: right;
  font-size: 13px
}
</style>